var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.657,
    height: 21.657,
    viewBox: "0 0 21.657 21.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.829 0a10.829 10.829 0 1 0 10.828 10.829A10.841 10.841 0 0 0 10.829 0zm.7 17.254c-.514.086-1.538.3-2.058.343a1.267 1.267 0 0 1-1.108-.577 1.353 1.353 0 0 1-.163-1.24l2.047-5.628H8.121a2.544 2.544 0 0 1 2-2.366 7.836 7.836 0 0 1 2.058-.341 1.632 1.632 0 0 1 1.108.577 1.353 1.353 0 0 1 .164 1.239l-2.047 5.628h2.128a2.4 2.4 0 0 1-2 2.364zm.649-10.486a1.354 1.354 0 1 1 1.354-1.354 1.354 1.354 0 0 1-1.354 1.354z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.62746131.svg";
export { ForwardRef as ReactComponent };